<template lang="pug">
  .chart-wrapper
    .title-wrapper
      .title {{$tc('ui.top_games')}}
      .update Last 30 days
    .chart
      .chart-bg
        .col
          //- span {{indicator_0}}
          span 100k
        .col
          //- span {{indicator_1}}
          span 200k
        .col
          //- span {{indicator_2}}
          span 300k
        .col
          //- span {{indicator_3}}
          span 400k
      ul
        li(v-for="(game, index) in topTenGames")
          img(:src="imageUrl + '/' + game.GameCode + '.png'")
          //- .bar.text-nowrap(:title="tooltipDisplay(game.BetAmount)"  :style="displayWidth(game.BetAmount)")
          .bar.text-nowrap(:style="displayWidth(game.BetAmount)")
            .game-name {{game.GameName}}
            //- .payout {{game.BetAmount}}
</template>
<script>
import config from '@/config'
import errorTags from '@/errorTags'
import game from '@/gameList'
export default {
  data(){
    return{
      feedback:{
        success: true,
        status:""
      },
      topTenGames:[],
      gameList: game,
      topTurnOver: "",
      topIndicator: "",
      indicator_0: "",
      indicator_1: "",
      indicator_2: "",
      indicator_3: "",
      refreshTimer: null,
      counter: 0,
      imageUrl: "",
      cacheList: [],
      cacheUrl:""
    }
  },
  mounted(){
    this.getTopTenGames()
    this.timer()   
  },
  beforeDestroy: function() {
    this.resetTimer()
  },
  methods:{
    getTopTenGames(){
      var md5 = require('md5')
      var aId = "wbepwnc"
      var dateTime = this.$moment().format("YYYY-MM-DD HH:mm:ss")
      var signature = md5(aId + dateTime + config.accessKey)
      var url = `https://vpmc999.ibacktech889.com/cwr/api/reality/overall-turnover-by-game`
      var json = {
        "aId": aId,
        "opId": "epicwinc",
        "requestDateTime": dateTime,
        "signature": signature 
      }
      this.$http.post(url, json).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              this.topTenGames = successResponse.data.Games
              this.cacheList = successResponse.data.Games
              this.imageUrl = successResponse.data.ThumbUrl
              this.cacheUrl = successResponse.data.ThumbUrl
              // this.topTurnOver = Math.ceil(successResponse.data.Games[0].BetAmount)
              // this.topTurnOver = Math.ceil(successResponse.data.Games[0].BetAmount/500) * 500
              // this.indicator_0 = this.topTurnOver * 0.25
              // this.indicator_1 = this.topTurnOver * 0.5
              // this.indicator_2 = this.topTurnOver * 0.75
              // this.indicator_3 = this.topTurnOver
              // if(this.topTurnOver.toString().length > 4){
              //   this.topTurnOver = Math.ceil(successResponse.data.Games[0].BetAmount/1000) * 1000
              //   this.indicator_0 = (this.topTurnOver * 0.25) + "k"
              //   this.indicator_1 = (this.topTurnOver * 0.5) + "k"
              //   this.indicator_2 = (this.topTurnOver * 0.75) + "k"
              //   this.indicator_3 = this.topTurnOver + "k"
              // }
            } else {
            }
          }else{
          }
        },
        errorResponse => {
          this.topTenGames = this.cacheList
          this.imageUrl = this.cacheUrl
          console.log(errorResponse)
        }
      );

    },
    displayWidth(amount){
      if(amount < 400000){
        return "width: " + (amount / 400000 * 100) + "%"
      }else{
        return "width: 100%"
      }
      
    },
    tooltipDisplay(amount){
      if(amount > 1000){
        return (amount / 100000) + "k"
      }else{
        return amount
      }
    },
    timer(){
      var vm = this
      this.refreshTimer = setInterval(() => {
        vm.getTopTenGames();
      }, 1200000)
    },
    resetTimer(){
      clearInterval(this.refreshTimer)
    },
  }
}
</script>
<style lang="scss" scoped>
// .tooltip {
//   position: relative;
//   display: inline-block;
//   border-bottom: 1px dotted black;
// }

// .tooltip .tooltiptext {
//   visibility: hidden;
//   width: 120px;
//   background-color: black;
//   color: #fff;
//   text-align: center;
//   border-radius: 6px;
//   padding: 5px 0;

//   /* Position the tooltip */
//   position: absolute;
//   z-index: 1;
// }

// .tooltip:hover .tooltiptext {
//   visibility: visible;
// }
</style>